import { RecordingStatus } from '@zoom/videosdk';
import { atom } from 'jotai';

export function isCloudRecordingActive(status: RecordingStatus): boolean {
  return status === RecordingStatus.Recording;
}

/** Zoom `recording-change` is typed as `{ state }` but may emit the status string at runtime. */
export function normalizeRecordingChangePayload(
  payload: RecordingStatus | { state: RecordingStatus },
): RecordingStatus {
  if (typeof payload === 'object' && payload !== null && 'state' in payload) {
    return payload.state;
  }

  return payload;
}

/** Cloud-recording ground truth from the active video SDK. `null` means no SDK signal observed yet. */
export const cloudRecordingStatusAtom = atom<RecordingStatus | null>(null);
